export default {
  APP_NAME: 'okubuy',
  API_HOST: process.env.VUE_APP_API_HOST,
  STATIC_HOST: process.env.VUE_APP_STATIC_HOST,
  BLACKEND_URL: process.env.VUE_APP_BLACKEND_URL,
  SECRET_KEY: process.env.VUE_APP_SECRET_KEY,
  API_VERSION: 'v1',
  API_STANDARDS_TREE: 'vnd',
  PUSHER_CONFIG: {
    key: 'fac04081d3be20af5ae0',
    cluster: 'ap1',
  },
  VUEX_STORE_KEY: 'okubuy-store',
  VUEX_STORE_STORAGE: window.localStorage,
  PAYPAL_CLIENT_ID: process.env.VUE_APP_PAYPAL_CLIENT_ID,
};
